import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container, Button, Row, Col, Tabs, Tab, Card } from "react-bootstrap";
import Avatar, { } from "react-avatar";

// import { ChatList } from "react-chat-elements";

export default function Chat({ permitted }) {

  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();

  const [key, setKey] = useState('group');
  const [msg, setMsg] = useState([]);
  const [text, setText] = useState("");
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);

  const projects = useSelector(
    (state) => state.lookup.project
  );


  const users = useSelector(
    (state) => state.lookup.user
  );

  const handleSelect = (select) => {
    if (select) {
      setSelected(select)
      setShow(true)
    }
    else {
      setSelected(null)
    }
  }

  const handleBack = () => {
    setShow(false);
    setSelected(null);
  }

  return (
    <React.Fragment>
      <Row>
        <Col md={4}>
        {/* <ChatList
        className='chat-list'
        dataSource={
          
          projects.map(e=>{
            return {
              avatar: 'data:image/png;base64, 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',
              alt: e.name,
              title: e.name,
              
              date: new Date(),
              unread: 3,
            }

            
          })
        }/> */}
        </Col>
        <Col md={8}>

        </Col>
      </Row>
      
      {
        // <Container fluid className="col-md-4">
        //   {
        //     !show ?
        //       <Tabs
        //         id="controlled-tab"
        //         activeKey={key}
        //         onSelect={(k) => setKey(k)}
        //         className="mb-1"
        //       >
        //         <Tab eventKey="group" title="Group">
        //           <Container className="overflow-auto">
        //             {
        //               projects ? projects.map((e, i) => {

        //                 return (
        //                   <Row key={`pro_${i}`} className="border">
        //                     <Col style={{ height: "40px" }} role="button" className="d-flex align-items-center" onClick={() => handleSelect(e)}>
        //                       <Avatar className="fw-bold" value={e.name.substring(0, 2).toUpperCase()} round={true} size="30" />
        //                       <span className="ps-4">{e.name}</span>
        //                     </Col>
        //                   </Row>)
        //               }) : null
        //             }

        //           </Container>
        //         </Tab>
        //         <Tab eventKey="individual" title="Individual">
        //           <Container className="overflow-auto">
        //             {
        //               users ? users.map((e, i) => {

        //                 return (
        //                   <Row key={`user_${i}`} className="border">
        //                     <Col style={{ height: "40px" }} role="button" className="d-flex align-items-center" onClick={() => handleSelect(e)}>
        //                       <Avatar className="fw-bold" value={e.name.substring(0, 2).toUpperCase()} round={true} size="30" />
        //                       <span className="ps-4">{e.name}</span>
        //                     </Col>
        //                   </Row>)
        //               }) : null
        //             }


        //           </Container>
        //         </Tab>
        //       </Tabs> :
        //       <React.Fragment>
        //         <Row className="border">
        //           <Col style={{ height: "50px" }} className="d-flex align-items-center">
        //             <i className="fa fa-chevron-left pe-2" role="button" onClick={handleBack}></i>

        //             <Avatar className="fw-bold" value={selected.name.substring(0, 2).toUpperCase()} round={true} size="30" />
        //             <span className="ps-4">{selected.name}</span>

        //           </Col>
        //         </Row>
        //         <Row>
        //           <Card className="p-0">
        //             <Card.Body className="overflow-auto" style={{ height: "80vh" }}>

        //               {
        //                 msg.map(e => {
        //                   return <div className="d-flex mb-3 rounded-3 border"> <div className="ms-auto bg-secondary p-1"> {e}</div></div>
        //                 })
        //               }
        //               <Container fluid className="p-0 position-absolute bottom-0 start-0 d-flex">
        //                 <textarea type="text" value={text ?? ""} onChange={(e) => setText(e.target.value)} className="form-control w-75"></textarea>
        //                 <Button variant="outline-light text-dark"><i className="fa fa-paperclip"></i> </Button>
        //                 <Button variant="outline-light text-dark" onClick={() => {

        //                   setMsg([...msg, text]);
        //                   setText("");
        //                 }}><i className="fa fa-send"></i> </Button>

        //               </Container>

        //             </Card.Body>
        //           </Card>

        //         </Row>
        //       </React.Fragment>
        //   }
        // </Container>
      }

    </React.Fragment >);
}

// }
